import { makeStyles } from '@material-ui/styles';
import { MDSChip, MDSTheme } from '@marqvision/mds/core';
import { IcoAddPlusOutline } from '@marqvision/mds/assets';
import { RequestFilter } from '../../@types';
import { TypeFilter } from './TypeFilter';
import { StatusFilter } from './StatusFilter';

const useStyles = makeStyles({
  wrapper: {
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: MDSTheme.palette.bluegray[50],
  },
});

type Props = {
  filter: RequestFilter;
  onFilter: (key: keyof RequestFilter, value: RequestFilter[keyof RequestFilter]) => void;
  onAddMode: () => void;
};

export const FilterSection = (props: Props) => {
  const { filter, onFilter, onAddMode } = props;
  const classes = useStyles();

  const handleFilterChange = (key: keyof RequestFilter) => (value: RequestFilter[keyof RequestFilter]) => {
    onFilter(key, value);
  };
  
  return (
    <div className={classes.wrapper}>
      <MDSChip
        variant="fill"
        color="blue"
        icon={<IcoAddPlusOutline />}
        label="Request"
        onClick={onAddMode}
      />
      <TypeFilter selected={filter.crType} onChange={handleFilterChange('crType')} />
      <StatusFilter selected={filter.crStatus} onChange={handleFilterChange('crStatus')} />
    </div>
  );
};